import client from '../client';

const authApi = {
  login: ({ countryCode, phone, password }) => client.post('/auth/login', { countryCode, phone, password }),
  /** purpose: 'login' | 'register' | 'reset' */
  requestOtp: ({ countryCode, phone, purpose }) => client.post('/auth/otp/request', { countryCode, phone, purpose }),
  verifyOtp: ({ countryCode, phone, code, purpose }) => client.post('/auth/otp/verify', { countryCode, phone, code, purpose }),
  register: (payload) => client.post('/auth/register', payload),
  resetPassword: ({ resetToken, password }) => client.post('/auth/password/reset', { resetToken, password }),
  me: () => client.get('/auth/me'),
  logout: () => client.post('/auth/logout'),
};

export default authApi;
